import { REGISTRATION_MESSAGE_TYPES } from '@buxus/shared'
import { showAppErrorModal } from '../platform/ui/appErrorModal'
import { hasNativeHostBridge, postNativeHostMessage } from '../platform/shell/nativeHostBridge'

/** True when the React Native shell can receive registration bridge messages. */
export function hasRegistrationNativeBridge(): boolean {
  return hasNativeHostBridge()
}

/** Leave registration: native login redirect when embedded, otherwise app home. */
export function leaveRegistrationHost(
  navigate: (to: string, options?: { replace?: boolean }) => void,
): void {
  if (hasRegistrationNativeBridge()) {
    postRedirectToLogin()
    return
  }
  navigate('/', { replace: true })
}

export function postRegistrationHostMessage(
  message: Parameters<typeof postNativeHostMessage>[0],
): void {
  postNativeHostMessage(message)
}

export function postRedirectToLogin(): void {
  postRegistrationHostMessage({ type: REGISTRATION_MESSAGE_TYPES.REDIRECT_TO_LOGIN })
}

export function postRedirectToProfile(): void {
  postRegistrationHostMessage({ type: REGISTRATION_MESSAGE_TYPES.REDIRECT_TO_PROFILE })
}

/** Leave invite flow: native Profile when embedded, otherwise app home. */
export function leaveInviteHost(
  navigate: (to: string, options?: { replace?: boolean }) => void,
): void {
  if (hasRegistrationNativeBridge()) {
    postRedirectToProfile()
    return
  }
  navigate('/', { replace: true })
}

export function postRedirectToUri(uri: string): void {
  postRegistrationHostMessage({
    type: REGISTRATION_MESSAGE_TYPES.REDIRECT_TO_URI,
    payload: { uri },
  })
}

export function postDisplayErrorModal(content: string, title?: string): void {
  showAppErrorModal({ title, message: content })
}

/** WebView success: explicit login handoff (no auto-login). */
export function postRegistrationCompleteToLogin(): void {
  postRedirectToLogin()
}
